async function waitForProperty(target, property, intervalMs = 100, timeoutMs = 5000) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const check = () => {
      if (property in target) {
        resolve(target[property]);
      } else if (Date.now() - startTime >= timeoutMs) {
        reject(new Error(`Property "${property}" not found within ${timeoutMs}ms`));
      } else {
        setTimeout(check, intervalMs);
      }
    };

    check();
  });
}

let adcellInitialized = false;

function initAdcell() {
  if (adcellInitialized) return;
  if (!window.Adcell || !window.Adcell.Tracking || typeof window.Adcell.Tracking.track !== "function") return;
  adcellInitialized = true;
  console.log("=== Initializing Adcell ===");
  window.Adcell.Tracking.track();
  console.log("=== Done \u2705 ===");
}

function tryInitAdcell() {
  waitForProperty(window, "Adcell")
    .then(initAdcell)
    .catch((e) => console.log("Adcell not initialized:", e.message));
}

window.addEventListener("PandectesEvent_OnConsent", tryInitAdcell);

tryInitAdcell();